import { makeRequest } from 'services/request.service'

export const getStats = () => makeRequest({ method: 'GET', url: '/dashboard/stats' })
export const getCatalog = () => makeRequest({ method: 'GET', url: '/catalog' })

export const listShipments = (params = {}) => makeRequest({ method: 'GET', url: '/shipments', params })
export const createShipment = (data) => makeRequest({ method: 'POST', url: '/shipments', data })
export const getShipment = (id) => makeRequest({ method: 'GET', url: `/shipments/${id}` })
export const updateShipment = (id, data) => makeRequest({ method: 'PUT', url: `/shipments/${id}`, data })
export const deleteShipment = (id) => makeRequest({ method: 'DELETE', url: `/shipments/${id}` })
export const calculateShipment = (id) => makeRequest({ method: 'POST', url: `/shipments/${id}/calculate`, data: {} })

// Export as a file download (auth header is applied by the interceptor).
export const exportShipment = async (id, format = 'json') => {
  const response = await makeRequest({ method: 'GET', url: `/shipments/${id}/export`, params: { format }, responseType: 'blob' })
  return response.data
}

export const createItem = (id, data) => makeRequest({ method: 'POST', url: `/shipments/${id}/items`, data })
export const updateItem = (id, itemId, data) => makeRequest({ method: 'PUT', url: `/shipments/${id}/items/${itemId}`, data })
export const deleteItem = (id, itemId) => makeRequest({ method: 'DELETE', url: `/shipments/${id}/items/${itemId}` })

export const createCostLine = (id, data) => makeRequest({ method: 'POST', url: `/shipments/${id}/cost-lines`, data })
export const updateCostLine = (id, lineId, data) => makeRequest({ method: 'PUT', url: `/shipments/${id}/cost-lines/${lineId}`, data })
export const confirmCostLine = (id, lineId) => makeRequest({ method: 'POST', url: `/shipments/${id}/cost-lines/${lineId}/confirm`, data: {} })
export const rejectCostLine = (id, lineId) => makeRequest({ method: 'POST', url: `/shipments/${id}/cost-lines/${lineId}/reject`, data: {} })
export const confirmAllCostLines = (id) => makeRequest({ method: 'POST', url: `/shipments/${id}/cost-lines/confirm-all`, data: {} })
export const deleteCostLine = (id, lineId) => makeRequest({ method: 'DELETE', url: `/shipments/${id}/cost-lines/${lineId}` })
export const refreshExchangeRates = (id) => makeRequest({ method: 'POST', url: `/shipments/${id}/exchange-rates/refresh`, data: {} })
